import { render, staticRenderFns } from "./WorkDocsDocumentTypeTableItem.vue?vue&type=template&id=378f6f18&"
import script from "./WorkDocsDocumentTypeTableItem.vue?vue&type=script&lang=js&"
export * from "./WorkDocsDocumentTypeTableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports